import Vue from 'vue'
import VueRouter, { RouteConfig, Route } from 'vue-router'
import ProductsPage from '../pages/products/products.page.vue'
import ProductPage from '../pages/product/product.page.vue'
import { config } from '@/setup/config'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: ProductsPage,
    beforeEnter: (to: Route, from: Route, next: Function) => {
      if (config.products.length === 1) {
        next({
          name: 'product',
          params: {
            productTitle: config.products[0].title
          }
        })
      } else {
        next()
      }
    }
  },
  {
    name: 'product',
    path: '/products/:productTitle',
    component: ProductPage,
    beforeEnter: (to: Route, from: Route, next: Function) => {
      const productTitle = to.params.productTitle
      if (config.products.some((product) => product.title === productTitle)) {
        next()
      } else {
        next({ path: '/' })
      }
    },
    props: (route: Route) => ({
      product: config.products.find((product) => product.title === route.params.productTitle),
    })
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
